import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Outcomes from "@/components/landing/Outcomes";
import Includes from "@/components/landing/Includes";
import PainPoint from "@/components/landing/PainPoint";
import Journey from "@/components/landing/Journey";
import Workshops from "@/components/landing/Workshops";
import Schedule from "@/components/landing/Schedule";
import DecisionGuide from "@/components/landing/DecisionGuide";
import Pricing from "@/components/landing/Pricing";
import Facilitator from "@/components/landing/Facilitator";
import Audience from "@/components/landing/Audience";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function Landing() {
    return (
        <main
            className="min-h-screen bg-white text-[color:var(--navy)] font-sans"
            data-testid="landing-page"
        >
            <Navbar />
            <Hero />
            <Outcomes />
            <Includes />
            <PainPoint />
            <Journey />
            <Workshops />
            <Schedule />
            <DecisionGuide />
            <Pricing />
            <Facilitator />
            <Audience />
            <FAQ />
            <FinalCTA />
            <Footer />
            <FloatingWhatsApp />
        </main>
    );
}
